// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import { Link as RouterLink } from "react-router-dom";
// import { useStyle } from "../../context/styleContext/styleContext";
// import {
//   Box,
//   Button,
//   Chip,
//   Paper,
//   Stack,
//   Typography,
// } from "@mui/material";

// import GraphicEqRoundedIcon from "@mui/icons-material/GraphicEqRounded";
// import SubscriptionsRoundedIcon from "@mui/icons-material/SubscriptionsRounded";
// import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
// import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
// import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";

// import SaleHeroBanner from "../../components/SaleHeroBanner/SaleHeroBanner.jsx";
// import Seo from "../../components/Seo";
// import HomePageProductCard from "../../components/ProductCard/HomePageProductCard";
// import HomeFeaturedProductCard from "../../components/ProductCard/HomeFeaturedProductCard";
// import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";

// const COLORS = {
//   page: "#05070A",
//   panel: "#111823",
//   raised: "#1B2533",
//   raisedHover: "#243144",
//   border: "#39495D",
//   borderStrong: "#526985",
//   text: "#F4F6F8",
//   muted: "#AEB8C5",
//   orange: "#FF9D2C",
//   gold: "#FFCF63",
//   buttonText: "#181109",
//   accentGreen: "rgb(24,146,80)",
//   brightAccentGreen: "rgb(38,166,104)"
// };

// const primaryButtonSx = {
//   minHeight: 46,
//   px: 2.5,
//   borderRadius: "8px",
//   textTransform: "none",
//   fontWeight: 900,
//   color: COLORS.buttonText,
//   backgroundColor: "#FFCC4D",
//   border: "1px solid #E7B93E",
//   boxShadow: "none",
//   transition: "background-color 160ms ease, border-color 160ms ease",
//   "&:hover": {
//     backgroundColor: "#FFD86B",
//     borderColor: "#F0C754",
//     boxShadow: "none",
//   },
// };

// const greenButtonSx = {
//   minHeight: 46,
//   px: 2.5,
//   borderRadius: "8px",
//   textTransform: "none",
//   fontWeight: 900,
//   color: COLORS.text,
//   backgroundColor: COLORS.accentGreen,
//   border: "1px solid",
//   borderColor:COLORS.buttonText,
//   boxShadow: "none",
//   transition: "background-color 160ms ease, border-color 160ms ease",
//   "&:hover": {
//     backgroundColor: COLORS.brightAccentGreen,
//     borderColor: COLORS.buttonText,
//     boxShadow: "none",
//   },
// };

// const secondaryButtonSx = {
//   minHeight: 46,
//   px: 2.5,
//   borderRadius: "8px",
//   textTransform: "none",
//   fontWeight: 800,
//   color: COLORS.text,
//   backgroundColor: COLORS.raised,
//   border: `1px solid ${COLORS.borderStrong}`,
//   transition: "background-color 160ms ease, border-color 160ms ease",
//   "&:hover": {
//     backgroundColor: COLORS.raisedHover,
//     borderColor: "#607896",
//   },
// };

// const sectionPaperSx = {
//   width: "100%",
//   minWidth: 0,
//   overflow: "hidden",
//   borderRadius: "14px",
//   backgroundColor: COLORS.panel,
//   border: `1px solid ${COLORS.border}`,
//   boxSizing: "border-box",
// };

// export default function Home() {
//   const [products, setProducts] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(true);
//   const { style } = useStyle();
//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "auto" });
//   }, []);

//   const getProductInfo = useCallback(async () => {
//     try {
//       setLoadingProducts(true);

//       const { data } = await axios.post(
//         "/api/get-products-available-on-website"
//       );

//       setProducts(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Error retrieving homepage products:", error);
//       setProducts([]);
//     } finally {
//       setLoadingProducts(false);
//     }
//   }, []);

//   useEffect(() => {
//     getProductInfo();
//   }, [getProductInfo]);

//   const featuredProduct = useMemo(() => {
//     return (
//       products.find((product) => product?.featuredOnHomepage === true) ||
//       products.find((product) => product?.productURI === "multiplier") ||
//       products[13] ||
//       products[7] ||
//       products.find((product) => Number(product?.price || 0) > 0) ||
//       null
//     );
//   }, [products]);

//   const highlightedProducts = useMemo(() => {
//     const selected = [];
//     const used = new Set();

//     const addProduct = (product) => {
//       if (!product) return;

//       const key = product._id || product.productURI || product.SKU;
//       if (!key || used.has(key)) return;

//       const featuredKey =
//         featuredProduct?._id ||
//         featuredProduct?.productURI ||
//         featuredProduct?.SKU;

//       if (featuredKey && key === featuredKey) return;

//       used.add(key);
//       selected.push(product);
//     };

//     products
//       .filter((product) => product?.homepageSection === "new")
//       .sort(
//         (a, b) =>
//           Number(a?.homepageOrder ?? 999) -
//           Number(b?.homepageOrder ?? 999)
//       )
//       .forEach(addProduct);

//     // Current fallback selection, preserved so this works before
//     // homepage merchandising fields are added to the product data.
//     [products[1], products[14], products[12]].forEach(addProduct);

//     // Fill any remaining positions with available products.
//     products.forEach(addProduct);

//     return selected.slice(0, 3);
//   }, [products, featuredProduct]);

//   return (
//     <>
//       <Seo
//         title="Parish Audio | Audio Plugins Built for Professionals"
//         description="Focused audio plugins for shaping tone, controlling mixes, and getting strong results quickly. Available for Windows VST3 and macOS VST3/AU."
//         canonical="https://parishaudio.com/"
//       />

//       <Box
//         component="main"
//         sx={{
//           width: "100%",
//           maxWidth: "100vw",
//           overflowX: "hidden",
//           backgroundColor: COLORS.page,
//           px: { xs: 1.25, sm: 1.75, md: 2.5 },
//           py: { xs: 1.5, md: 2.5 },
//           boxSizing: "border-box",
//         }}
//       >
//         <Box
//           sx={{
//             width: "100%",
//             maxWidth: 1180,
//             mx: "auto",
//             minWidth: 0,
//           }}
//         >
//           <Stack spacing={{ xs: 2, md: 2.5 }}>
//             <SaleHeroBanner />

//             <Paper
//               elevation={0}
//               sx={{
//                 ...sectionPaperSx,
//                 backgroundColor: COLORS.panel,
//               }}
//             >
//               <Box sx={{ p: { xs: 2.25, sm: 3, md: 4 } }}>
//                 <Stack
//                   direction={{ xs: "column", md: "row" }}
//                   spacing={{ xs: 2.5, md: 4 }}
//                   alignItems={{ xs: "stretch", md: "center" }}
//                   justifyContent="space-between"
//                 >
//                   <Box sx={{ maxWidth: 720 }}>
//                     <Chip
//                       icon={<GraphicEqRoundedIcon />}
//                       label="Premium Audio Plugins"
//                       sx={{
//                         mb: 1.6,
//                         height: 30,
//                         borderRadius: "6px",
//                         color: style.accentGreen,
//                         backgroundColor: "rgba(255, 207, 99, 0.08)",
//                         border: "1px solid rgba(255, 207, 99, 0.22)",
//                         fontWeight: 900,
//                         letterSpacing: "0.055em",
//                         textTransform: "uppercase",
//                         "& .MuiChip-icon": {
//                           color: style.accentGreen,
//                         },
//                       }}
//                     />

//                     <Typography
//                       component="h1"
//                       sx={{
//                         color: COLORS.text,
//                         fontWeight: 900,
//                         letterSpacing: "-0.045em",
//                         lineHeight: 0.98,
//                         fontSize: {
//                           xs: "1.25rem",
//                           sm: "1.75rem",
//                           md: "2rem",
//                         },
//                         maxWidth: 700,
//                       }}
//                     >
//                       Audio plugins built for professionals.
//                     </Typography>

//                     <Typography
//                       sx={{
//                         mt: 1.6,
//                         maxWidth: 670,
//                         color: COLORS.muted,
//                         fontSize: {
//                           xs: "1rem",
//                           sm: "1.08rem",
//                           md: "1.15rem",
//                         },
//                         lineHeight: 1.7,
//                       }}
//                     >
//                       Professional tools for shaping tone, controlling mixes, and
//                      perfecting your project.
//                     </Typography>
//                   </Box>

//                   <Stack
//                     direction={{ xs: "column", sm: "row", md: "column" }}
//                     spacing={1}
//                     sx={{
//                       width: { xs: "100%", md: 250 },
//                       flexShrink: 0,
//                     }}
//                   >
//                     <Button
//                       component={RouterLink}
//                       to="/products"
//                       endIcon={<ArrowForwardRoundedIcon />}
//                       sx={{ ...greenButtonSx, width: "100%" }}
//                     >
//                       Explore Plugins
//                     </Button>

//                     <Button
//                       component={RouterLink}
//                       to="/subscribe"
//                       startIcon={<SubscriptionsRoundedIcon />}
//                       sx={{ ...secondaryButtonSx, width: "100%" }}
//                     >
//                       Try Full Access Free
//                     </Button>
//                   </Stack>
//                 </Stack>
//               </Box>

//               <Box
//                 sx={{
//                   px: { xs: 2, md: 3 },
//                   py: 1.35,
//                   borderTop: "1px solid rgba(255,255,255,0.07)",
//                   backgroundColor: "rgba(0,0,0,0.18)",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "grid",
//                     gridTemplateColumns: {
//                       xs: "1fr",
//                       sm: "repeat(2, minmax(0, 1fr))",
//                       md: "repeat(4, minmax(0, 1fr))",
//                     },
//                     gap: { xs: 0.8, md: 1.5 },
//                   }}
//                 >
//                   <TrustItem
//                     icon={<DownloadRoundedIcon />}
//                     text="Instant downloads"
//                   />
//                   <TrustItem
//                     icon={<CheckCircleRoundedIcon />}
//                     text="Windows VST3"
//                   />
//                   <TrustItem
//                     icon={<CheckCircleRoundedIcon />}
//                     text="macOS VST3 + AU"
//                   />
//                   <TrustItem
//                     icon={<SubscriptionsRoundedIcon />}
//                     text="7-day Full Access trial"
//                   />
//                 </Box>
//               </Box>
//             </Paper>

//             {featuredProduct && (
//               <Paper elevation={0} sx={sectionPaperSx}>
//                 <SectionHeader
//                   eyebrow="Featured"
//                   title="Featured Plugin"
//                 />

//                 <Box sx={{ p: { xs: 1.25, sm: 1.5, md: 1.75 } }}>
//                   <HomeFeaturedProductCard productData={featuredProduct} />
//                 </Box>
//               </Paper>
//             )}

//             <Paper elevation={0} sx={sectionPaperSx}>
//               <SectionHeader
//                 eyebrow="Explore"
//                 title="New & Noteworthy"
//                 action={
//                   <Button
//                     component={RouterLink}
//                     to="/products"
//                     endIcon={<ArrowForwardRoundedIcon />}
//                     sx={{
//                       ...secondaryButtonSx,
//                       minHeight: 42,
//                       width: { xs: "100%", sm: "auto" },
//                       minWidth: { sm: 190 },
//                     }}
//                   >
//                     Shop All Plugins
//                   </Button>
//                 }
//               />

//               <Box sx={{ p: { xs: 1.25, sm: 1.5, md: 1.75 } }}>
//                 {loadingProducts ? (
//                   <Box sx={{ py: 5 }}>
//                     <LoadingSpinner />
//                   </Box>
//                 ) : (
//                   <Box
//                     sx={{
//                       display: "grid",
//                       gridTemplateColumns: {
//                         xs: "1fr",
//                         md: "repeat(3, minmax(0, 1fr))",
//                       },
//                       gap: 2,
//                     }}
//                   >
//                     {highlightedProducts.map((product, index) => (
//                       <Box
//                         key={
//                           product?._id ||
//                           product?.productURI ||
//                           product?.SKU ||
//                           index
//                         }
//                         sx={{ minWidth: 0 }}
//                       >
//                         <HomePageProductCard productData={product} />
//                       </Box>
//                     ))}
//                   </Box>
//                 )}
//               </Box>
//             </Paper>

//             <Paper
//               elevation={0}
//               sx={{
//                 ...sectionPaperSx,
//                 backgroundColor: COLORS.panel,
//               }}
//             >
//               <Box sx={{ p: { xs: 2.25, sm: 3, md: 3.5 } }}>
//                 <Stack
//                   direction={{ xs: "column", md: "row" }}
//                   spacing={{ xs: 2.5, md: 4 }}
//                   alignItems={{ xs: "stretch", md: "center" }}
//                   justifyContent="space-between"
//                 >
//                   <Box sx={{ maxWidth: 760 }}>
//                     <Typography
//                       sx={{
//                         mb: 0.7,
//                         color: COLORS.gold,
//                         fontSize: "0.75rem",
//                         fontWeight: 900,
//                         letterSpacing: "0.14em",
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Full Access Pass
//                     </Typography>

//                     <Typography
//                       component="h2"
//                       sx={{
//                         color: COLORS.text,
//                         fontWeight: 900,
//                         lineHeight: 1.08,
//                         letterSpacing: "-0.025em",
//                         fontSize: { xs: "1.55rem", md: "2.15rem" },
//                       }}
//                     >
//                       Every Parish Audio plugin. One subscription.
//                     </Typography>

//                     <Typography
//                       sx={{
//                         mt: 1,
//                         color: COLORS.muted,
//                         lineHeight: 1.7,
//                         fontSize: { xs: "0.98rem", md: "1.06rem" },
//                       }}
//                     >
//                       Try the full lineup free for 7 days, then continue for
//                       $9.95 per month. Cancel anytime.
//                     </Typography>
//                   </Box>

//                   <Stack
//                     direction={{ xs: "column", sm: "row", md: "column" }}
//                     spacing={1}
//                     sx={{
//                       width: { xs: "100%", md: 245 },
//                       flexShrink: 0,
//                     }}
//                   >
//                     <Button
//                       component={RouterLink}
//                       to="/subscribe"
//                       startIcon={<SubscriptionsRoundedIcon />}
//                       sx={{ ...greenButtonSx, width: "100%" }}
//                     >
//                       Start 7-Day Trial
//                     </Button>

//                     <Button
//                       component={RouterLink}
//                       to="/products"
//                       endIcon={<ArrowForwardRoundedIcon />}
//                       sx={{ ...secondaryButtonSx, width: "100%" }}
//                     >
//                       See What’s Included
//                     </Button>
//                   </Stack>
//                 </Stack>
//               </Box>
//             </Paper>
//           </Stack>
//         </Box>
//       </Box>
//     </>
//   );
// }

// function SectionHeader({ eyebrow, title, action = null }) {
//   return (
//     <Box
//       sx={{
//         px: { xs: 1.5, sm: 2, md: 2.5 },
//         py: { xs: 1.4, md: 1.6 },
//         backgroundColor: COLORS.raised,
//         borderBottom: "1px solid rgba(255,255,255,0.08)",
//       }}
//     >
//       <Stack
//         direction={{ xs: "column", sm: "row" }}
//         spacing={1.25}
//         alignItems={{ xs: "stretch", sm: "center" }}
//         justifyContent="space-between"
//       >
//         <Box>
//           <Typography
//             sx={{
//               mb: 0.25,
//               color: COLORS.gold,
//               fontSize: "0.7rem",
//               fontWeight: 900,
//               letterSpacing: "0.14em",
//               textTransform: "uppercase",
//             }}
//           >
//             {eyebrow}
//           </Typography>

//           <Typography
//             component="h2"
//             sx={{
//               color: COLORS.text,
//               fontWeight: 900,
//               fontSize: { xs: "1.3rem", md: "1.6rem" },
//               lineHeight: 1.1,
//               letterSpacing: "-0.015em",
//             }}
//           >
//             {title}
//           </Typography>
//         </Box>

//         {action}
//       </Stack>
//     </Box>
//   );
// }

// function TrustItem({ icon, text }) {
//   const { style } = useStyle();

//   return (
//     <Stack
//       direction="row"
//       spacing={0.8}
//       alignItems="center"
//       justifyContent={{ xs: "flex-start", md: "center" }}
//       sx={{
//         color: COLORS.muted,
//         minWidth: 0,
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           flexShrink: 0,
//           color: style.accentGreen,
//           "& svg": {
//             fontSize: 18,
//           },
//         }}
//       >
//         {icon}
//       </Box>

//       <Typography
//         sx={{
//           fontSize: "0.88rem",
//           fontWeight: 700,
//           lineHeight: 1.3,
//         }}
//       >
//         {text}
//       </Typography>
//     </Stack>
//   );
// }


import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";

import { useStyle } from "../../context/styleContext/styleContext";
import SaleHeroBanner from "../../components/SaleHeroBanner/SaleHeroBanner.jsx"
import Seo from "../../components/Seo";

import {
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import GraphicEqRoundedIcon from "@mui/icons-material/GraphicEqRounded";
import SubscriptionsRoundedIcon from "@mui/icons-material/SubscriptionsRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { Facebook, YouTube, X } from "@mui/icons-material";

import HomePageProductCard from "../../components/ProductCard/HomePageProductCard";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import HomeFeaturedProductCard from "../../components/ProductCard/HomeFeaturedProductCard";

export default function Home() {
  const { style } = useStyle();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [dataForAllProducts, setDataForAllProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const getProductInfo = useCallback(async () => {
    try {
      setLoadingProducts(true);
      const { data } = await axios.post("/api/get-products-available-on-website");

      if (data) {
        setDataForAllProducts(data);
      } else {
        console.log("data error");
      }
    } catch (error) {
      console.log("Error retrieving data...", error);
    } finally {
      setLoadingProducts(false);
    }
  }, []);

  useEffect(() => {
    getProductInfo();
  }, [getProductInfo]);

  const featuredProduct = useMemo(() => {
    return dataForAllProducts[13] || dataForAllProducts[7] || null;
  }, [dataForAllProducts]);

  const newReleaseProducts = useMemo(() => {
    let data = [dataForAllProducts[1], dataForAllProducts[14], dataForAllProducts[12]]

    return data;
  }, [dataForAllProducts]);

  return (
    <>
      <Seo
        title="Parish Audio | Professional Audio Plugins"
        description="Discover Parish Audio plugins for mixing, sound design, songwriting, and modern production. Instant downloads for Mac and Windows."
        canonical="https://parishaudio.com/"
      />

      <Box
        sx={{
          width: "100%",
          maxWidth: "100vw",
          overflowX: "hidden",
          backgroundColor: "black",
          px: { xs: 1.25, sm: 1.5, md: 2.5 },
          py: { xs: 1.5, md: 2.5 },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 1120,
            mx: "auto",
            minWidth: 0,
          }}
        >
          <SaleHeroBanner />
          <br />
          <Stack spacing={{ xs: 2, md: 2.5, mt: 1 }}>
            {/* <Paper
              sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "20px",
                width: "100%",
                minHeight: { xs: 360, sm: 400, md: 450, lg: 450 },
                display: "flex",
                alignItems: { xs: "stretch", md: "center" },
                backgroundColor: "black",
                border: `1px solid ${style.color2}`,
                boxSizing: "border-box",
                backgroundImage: `
                  linear-gradient(
                    90deg,
                    rgba(8, 12, 18, 0.84) 0%,
                    rgba(8, 12, 18, 0.74) 34%,
                    rgba(8, 12, 18, 0.52) 62%,
                    rgba(8, 12, 18, 0.46) 100%
                  ),
                  url('/assets/HeroBanner.webp')
                `,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
              }}
              elevation={0}
            >
              <Box
                sx={{
                  width: "100%",
                  p: { xs: 2, sm: 3, md: 4 },
                  display: "flex",
                  alignItems: "center",
                  minWidth: 0,
                }}
              >
                <Box
                  sx={{
                    maxWidth: 620,
                    minWidth: 0,
                  }}
                >
                  <Stack spacing={1.25} alignItems="flex-start">
                    <Chip
                      icon={<GraphicEqRoundedIcon />}
                      label="Professional Audio Plugins"
                      sx={{
                        borderRadius: "5px",
                        fontWeight: 700,
                        color: style.color4,
                        backgroundColor: "rgba(255,255,255,0.08)",
                        border: "1px solid rgba(255,255,255,0.10)",
                      }}
                    />
<Typography
                      component="h1"
                      sx={{
                        color: style.color4,
                        fontWeight: 800,
                        lineHeight: 1.02,
                        fontSize: {
                          xs: "2rem",
                          sm: "2.5rem",
                          md: "3.5rem",
                        },
                        letterSpacing: "-0.04em",
                        textShadow: "0 6px 24px rgba(0,0,0,0.35)",
                        mb:5,
                      }}
                    >
                      Parish Audio
                    </Typography>
                    <Typography
                      component="h2"
                      sx={{
                        color: style.color4,
                        fontWeight: 800,
                        lineHeight: 1.02,
                        fontSize: {
                          xs: "1.25rem",
                          sm: "1.5rem",
                          md: "1.75rem",
                        },
                        letterSpacing: "-0.04em",
                        textShadow: "0 6px 24px rgba(0,0,0,0.35)",
                      }}
                    >
                      Powerful sound.
                      <br />
                      Designed for modern production.
                    </Typography>

                    <Typography
                      sx={{
                        color: "rgba(255,255,255,0.88)",
                        maxWidth: 560,
                        fontSize: {
                          xs: "0.98rem",
                          sm: "1.05rem",
                          md: "1.14rem",
                        },
                        lineHeight: 1.7,
                        textShadow: "0 4px 20px rgba(0,0,0,0.28)",
                      }}
                    >
                      Professional tools for mixing, sound design, songwriting,
                      and recording. Available on Mac and Windows.
                    </Typography>

                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={1.25}
                      sx={{ pt: 0.75, width: { xs: "100%", sm: "auto" } }}
                    >
                      <Button
                        component={RouterLink}
                        to="/products"
                        sx={{
                          borderRadius: "5px",
                          textTransform: "none",
                          fontWeight: 700,
                          color: style.color4,
                          backgroundColor: style.accentGreen,
                          minWidth: { sm: 180 },
                          "&:hover": {
                            backgroundColor: style.accentGreen,
                            filter: "brightness(1.05)",
                          },
                        }}
                      >
                        Browse Plugins
                      </Button>

                      <Button
                        component={RouterLink}
                        to="/subscribe"
                        startIcon={<SubscriptionsRoundedIcon />}
                        sx={{
                          borderRadius: "5px",
                          textTransform: "none",
                          fontWeight: 700,
                          color: style.color4,
                          backgroundColor: "rgba(255,255,255,0.06)",
                          border: "1px solid rgba(255,255,255,0.14)",
                          minWidth: { sm: 180 },
                          "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.12)",
                          },
                        }}
                      >
                        Start Free Trial
                      </Button>
                    </Stack>

                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      spacing={1}
                      flexWrap="wrap"
                      useFlexGap
                      sx={{ pt: 0.5 }}
                    >
                      <HeroPill
                        icon={<DownloadRoundedIcon sx={{ fontSize: 18 }} />}
                        text="Instant downloads"
                        style={style}
                      />
                      <HeroPill
                        icon={<CheckCircleRoundedIcon sx={{ fontSize: 18 }} />}
                        text="Mac + Windows"
                        style={style}
                      />
                    </Stack>
                  </Stack>
                </Box>
              </Box>
            </Paper> */}
            {/* <Typography
                    variant="h1"
                    sx={{
                      color: "white",
                      fontWeight: 800,
                      lineHeight: 1.02,
                      fontSize: {
                        xs: "1.175rem",
                        sm: "1.5rem",
                        md: "2rem",
                      },
                      textShadow: "0 4px 24px rgba(0,0,0,0.45)",
                    }}
                  >
                    Parish Audio 
                  </Typography> */}
            {featuredProduct && (
              <Paper
                elevation={0}
                sx={{
                  width: "100%",
                  minWidth: 0,
                  borderRadius: "20px",
                  overflow: "hidden",
                  backgroundColor: style.color1,
                  border: `1px solid ${style.color2}`,
                  boxSizing: "border-box",
                }}
              >
                <Box
                  sx={{
                    px: { xs: 1.5, sm: 2, md: 2.5 },
                    py: { xs: 1.25, md: 1.5 },
                    borderBottom: `1px solid rgba(255,255,255,0.08)`,
                    backgroundColor: style.darkPanel,
                  }}
                >
                  <Typography
                    component="h1"
                    sx={{
                      color: style.color4,
                      fontWeight: 800,
                      fontSize: { xs: "1.25rem", md: "1.5rem" },
                    }}
                  >
                    Parish Audio - Featured Plugin
                  </Typography>
                </Box>

                <Box sx={{ p: { xs: 1.25, md: 1.5 } }}>
                  <HomeFeaturedProductCard productData={featuredProduct} />
                </Box>
              </Paper>
            )}

<Paper
              elevation={0}
              sx={{
                width: "100%",
                minWidth: 0,
                borderRadius: "20px",
                backgroundColor: style.darkPanel,
                border: `1px solid ${style.color2}`,
                p: { xs: 2, sm: 2.5, md: 3 },
                boxSizing: "border-box",
                overflow: "hidden",
              }}
            >
              <Stack spacing={1.5} alignItems="center" textAlign="center">
                <Typography
                  sx={{
                    color: style.color4,
                    fontWeight: 800,
                    fontSize: { xs: "1.55rem", md: "2rem" },
                    lineHeight: 1.1,
                  }}
                >
                  Ready to find the perfect tool for your sound?
                </Typography>

                <Typography
                  sx={{
                    color: style.color3,
                    lineHeight: 1.7,
                    maxWidth: 680,
                  }}
                >
                  Browse the full plugin catalog, or try everything free with the Full Access Pass.
                </Typography>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={1}
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  <Button
                    component={RouterLink}
                    to="/products"
                    sx={{
                      borderRadius: "5px",
                      textTransform: "none",
                      fontWeight: 800,
                      color: style.color4,
                      backgroundColor: style.accentGreen,
                      minWidth: { sm: 180 },
                      minHeight: 44,
                      "&:hover": {
                        backgroundColor: style.accentGreen,
                        filter: "brightness(1.05)",
                      },
                    }}
                  >
                    Browse All Plugins
                  </Button>

                  <Button
                    component={RouterLink}
                    to="/subscribe"
                    sx={{
                      borderRadius: "5px",
                      textTransform: "none",
                      fontWeight: 800,
                      color: style.color4,
                      backgroundColor: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.10)",
                      minWidth: { sm: 180 },
                      minHeight: 44,
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.10)",
                      },
                    }}
                  >
                    Start Free Trial
                  </Button>
                </Stack>
              </Stack>
            </Paper>

            {/* <Paper
              elevation={0}
              sx={{
                width: "100%",
                minWidth: 0,
                borderRadius: "20px",
                overflow: "hidden",
                backgroundColor: style.color1,
                border: `1px solid ${style.color2}`,
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 1.5, md: 2 },
                  backgroundColor: style.darkPanel,
                  borderBottom: `1px solid rgba(255,255,255,0.08)`,
                }}
              >
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  spacing={2}
                  alignItems={{ xs: "flex-start", md: "center" }}
                  justifyContent="space-between"
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Chip
                      label="Subscription"
                      sx={{
                        mb: 1,
                        borderRadius: "5px",
                        fontWeight: 700,
                        color: style.color4,
                        backgroundColor: "rgba(255,255,255,0.06)",
                      }}
                    />
                    <Typography
                      sx={{
                        color: style.color4,
                        fontWeight: 800,
                        fontSize: { xs: "1.35rem", md: "1.8rem" },
                        lineHeight: 1.08,
                      }}
                    >
                      Full Access Pass - Get everything with one subscription
                    </Typography>
                    <Typography
                      sx={{
                        color: style.color3,
                        lineHeight: 1.7,
                        mt: 0.9,
                        maxWidth: 760,
                      }}
                    >
                      Try the full lineup of plugins with a 7-day free trial, then $9.95 per month. Cancel anytime.
                    </Typography>
                  </Box>

                  <Stack
                    direction={{ xs: "column", sm: "row", md: "column" }}
                    spacing={1}
                    sx={{ width: { xs: "100%", md: "auto" } }}
                  >
                    <Button
                      component={RouterLink}
                      to="/subscribe"
                      startIcon={<SubscriptionsRoundedIcon />}
                      sx={{
                        borderRadius: "5px",
                        textTransform: "none",
                        fontWeight: 700,
                        color: style.color4,
                        backgroundColor: style.accentGreen,
                        minWidth: { md: 220 },
                        "&:hover": {
                          backgroundColor: style.accentGreen,
                          filter: "brightness(1.05)",
                        },
                      }}
                    >
                      Start Your Free Trial
                    </Button>

                    <Button
                      component={RouterLink}
                      to="/products"
                      endIcon={<ArrowForwardRoundedIcon />}
                      sx={{
                        borderRadius: "5px",
                        textTransform: "none",
                        fontWeight: 700,
                        color: style.color4,
                        backgroundColor: "rgba(255,255,255,0.05)",
                        border: "1px solid rgba(255,255,255,0.10)",
                        minWidth: { md: 220 },
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.10)",
                        },
                      }}
                    >
                      Explore Plugins
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Paper> */}

            <Paper
              elevation={0}
              sx={{
                width: "100%",
                minWidth: 0,
                borderRadius: "20px",
                overflow: "hidden",
                backgroundColor: style.color1,
                border: `1px solid ${style.color2}`,
                boxSizing: "border-box",
              }}
            >

<Box

  sx={{
    px: { xs: 1.5, sm: 2, md: 2.5 },
    py: { xs: 1.25, md: 1.5 },
    borderBottom: `1px solid rgba(255,255,255,0.08)`,
    backgroundColor: style.darkPanel,
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    justifyContent: "space-between",
    gap: 1.25,
  }}
>
  <Typography
    component="h3"
    sx={{
      color: style.color4,
      fontWeight: 800,
      fontSize: { xs: "1.25rem", md: "1.5rem" },
    }}
  >
    Suggested Plugins:
  </Typography>

  <Button
    component={RouterLink}
    to="/products"
    endIcon={<ArrowForwardRoundedIcon />}
    sx={{
      borderRadius: "5px",
      textTransform: "none",
      fontWeight: 700,
      color: style.color4,
      backgroundColor: "rgba(255,255,255,0.05)",
      border: "1px solid rgba(255,255,255,0.10)",
      minWidth: { xs: "100%", sm: 180, md: 220 },
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.10)",
      },
    }}
  >
    Shop All Plugins
  </Button>
</Box>


              {/* <Box
                sx={{
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 1.25, md: 1.5 },
                  borderBottom: `1px solid rgba(255,255,255,0.08)`,
                  backgroundColor: style.darkPanel,
                }}
              >
                <div style={{display:'flex', flexDirection:'row'}}>
                <Typography
                  component="h3"
                  sx={{
                    color: style.color4,
                    fontWeight: 800,
                    fontSize: { xs: "1.25rem", md: "1.5rem" },
                  }}
                >
                  Products:
                </Typography>

                <Button
                      component={RouterLink}
                      to="/products"
                      endIcon={<ArrowForwardRoundedIcon />}
                      sx={{
                        borderRadius: "5px",
                        textTransform: "none",
                        fontWeight: 700,
                        color: style.color4,
                        backgroundColor: "rgba(255,255,255,0.05)",
                        border: "1px solid rgba(255,255,255,0.10)",
                        minWidth: { md: 220 },
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.10)",
                        },
                      }}
                    >
                      Shop All Plugins
                    </Button>

                </div>
                
              </Box> */}

              <Box sx={{ p: { xs: 1.25, md: 1.5 } }}>
                {loadingProducts ? (
                  <Box sx={{ py: 4 }}>
                    <LoadingSpinner />
                  </Box>
                ) : (
                  <>
                    {!isMobile && newReleaseProducts.length > 0 && (
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                          gap: 2,
                        }}
                      >
                        {newReleaseProducts.map((product, index) => (
                          <Box
                            key={product?._id || product?.productURI || index}
                            sx={{ minWidth: 0 }}
                          >
                            <HomePageProductCard productData={product} />
                          </Box>
                        ))}
                      </Box>
                    )}

                    {isMobile && (
                      <Stack spacing={1.25}>
                        {newReleaseProducts && newReleaseProducts.length > 0 ? (
                          newReleaseProducts.map((product, index) => (
                            <Box
                              key={product?._id || product?.productURI || index}
                              sx={{ minWidth: 0 }}
                            >
                              <HomePageProductCard productData={product} />
                            </Box>
                          ))
                        ) : null}
                      </Stack>
                    )}
                  </>
                )}
              </Box>
            </Paper>
            {/* <Paper
              elevation={0}
              sx={{
                width: "100%",
                minWidth: 0,
                borderRadius: "20px",
                backgroundColor: style.darkPanel,
                border: `1px solid ${style.color2}`,
                p: { xs: 2, sm: 2.5, md: 3 },
                boxSizing: "border-box",
                overflow: "hidden",
              }}
            >
              <Stack spacing={1.5} alignItems="center" textAlign="center">
                <Typography
                  sx={{
                    color: style.color4,
                    fontWeight: 800,
                    fontSize: { xs: "1.55rem", md: "2rem" },
                    lineHeight: 1.1,
                  }}
                >
                  Ready to find the perfect tool for your sound?
                </Typography>

                <Typography
                  sx={{
                    color: style.color3,
                    lineHeight: 1.7,
                    maxWidth: 680,
                  }}
                >
                  Browse the full plugin catalog, or try everything free with the Full Access Pass.
                </Typography>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={1}
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  <Button
                    component={RouterLink}
                    to="/products"
                    sx={{
                      borderRadius: "5px",
                      textTransform: "none",
                      fontWeight: 800,
                      color: style.color4,
                      backgroundColor: style.accentGreen,
                      minWidth: { sm: 180 },
                      minHeight: 44,
                      "&:hover": {
                        backgroundColor: style.accentGreen,
                        filter: "brightness(1.05)",
                      },
                    }}
                  >
                    Browse All Plugins
                  </Button>

                  <Button
                    component={RouterLink}
                    to="/subscribe"
                    sx={{
                      borderRadius: "5px",
                      textTransform: "none",
                      fontWeight: 800,
                      color: style.color4,
                      backgroundColor: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.10)",
                      minWidth: { sm: 180 },
                      minHeight: 44,
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.10)",
                      },
                    }}
                  >
                    Start Free Trial
                  </Button>
                </Stack>
              </Stack>
            </Paper> */}

<Paper
              elevation={0}
              sx={{
                width: "100%",
                minWidth: 0,
                borderRadius: "20px",
                overflow: "hidden",
                backgroundColor: style.color1,
                border: `1px solid ${style.color2}`,
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 1.5, md: 2 },
                  backgroundColor: style.darkPanel,
                  borderBottom: `1px solid rgba(255,255,255,0.08)`,
                }}
              >
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  spacing={2}
                  alignItems={{ xs: "flex-start", md: "center" }}
                  justifyContent="space-between"
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Chip
                      label="Subscription"
                      sx={{
                        mb: 1,
                        borderRadius: "5px",
                        fontWeight: 700,
                        color: style.color4,
                        backgroundColor: "rgba(255,255,255,0.06)",
                      }}
                    />
                    <Typography
                      sx={{
                        color: style.color4,
                        fontWeight: 800,
                        fontSize: { xs: "1.35rem", md: "1.8rem" },
                        lineHeight: 1.08,
                      }}
                    >
                      Full Access Pass - Get everything with one subscription
                    </Typography>
                    <Typography
                      sx={{
                        color: style.color3,
                        lineHeight: 1.7,
                        mt: 0.9,
                        maxWidth: 760,
                      }}
                    >
                      Try the full lineup of plugins with a 7-day free trial, then $9.95 per month. Cancel anytime.
                    </Typography>
                  </Box>

                  <Stack
                    direction={{ xs: "column", sm: "row", md: "column" }}
                    spacing={1}
                    sx={{ width: { xs: "100%", md: "auto" } }}
                  >
                    <Button
                      component={RouterLink}
                      to="/subscribe"
                      startIcon={<SubscriptionsRoundedIcon />}
                      sx={{
                        borderRadius: "5px",
                        textTransform: "none",
                        fontWeight: 700,
                        color: style.color4,
                        backgroundColor: style.accentGreen,
                        minWidth: { md: 220 },
                        "&:hover": {
                          backgroundColor: style.accentGreen,
                          filter: "brightness(1.05)",
                        },
                      }}
                    >
                      Start Your Free Trial
                    </Button>

                    <Button
                      component={RouterLink}
                      to="/products"
                      endIcon={<ArrowForwardRoundedIcon />}
                      sx={{
                        borderRadius: "5px",
                        textTransform: "none",
                        fontWeight: 700,
                        color: style.color4,
                        backgroundColor: "rgba(255,255,255,0.05)",
                        border: "1px solid rgba(255,255,255,0.10)",
                        minWidth: { md: 220 },
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.10)",
                        },
                      }}
                    >
                      Explore Plugins
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Paper>

            <Paper
  elevation={0}
  sx={{
    width: "100%",
    minWidth: 0,
    borderRadius: "20px",
    backgroundColor: style.color1,
    border: `1px solid ${style.color2}`,
    p: { xs: 1.5, sm: 2 },
    boxSizing: "border-box",
    overflow: "hidden",
  }}
>
  <Stack spacing={1.25} alignItems="center" textAlign="center" sx={{ minWidth: 0 }}>
    <Typography
      sx={{
        color: style.color4,
        fontWeight: 800,
        fontSize: { xs: "1.1rem", md: "1.25rem" },
      }}
    >
      Find us on
    </Typography>

    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: { xs: 2, sm: 2.25 },
        flexWrap: "wrap",
        boxSizing: "border-box",
      }}
    >
      <a
        href="https://facebook.com/parishaudio"
        aria-label="Visit Parish Audio on Facebook"
        style={{ display: "flex", alignItems: "center", flexShrink: 0 }}
      >
        <Facebook
          sx={{
            fontSize: 34,
            color: "#1877F2",
            transition: "transform 0.2s ease, filter 0.2s ease",
            "&:hover": {
              transform: "scale(1.08)",
              filter: "brightness(1.08)",
            },
          }}
        />
      </a>

      <a
        href="https://x.com/Parish_Audio"
        aria-label="Visit Parish Audio on X"
        style={{ display: "flex", alignItems: "center", flexShrink: 0 }}
      >
        <X
          sx={{
            fontSize: 29,
            color: style.color4,
            transition: "transform 0.2s ease, filter 0.2s ease",
            "&:hover": {
              transform: "scale(1.08)",
              filter: "brightness(1.08)",
            },
          }}
        />
      </a>

      <a
        href="https://youtube.com/@ParishAudio"
        aria-label="Visit Parish Audio on YouTube"
        style={{ display: "flex", alignItems: "center", flexShrink: 0 }}
      >
        <YouTube
          sx={{
            fontSize: 40,
            color: "#FF0000",
            transition: "transform 0.2s ease, filter 0.2s ease",
            "&:hover": {
              transform: "scale(1.08)",
              filter: "brightness(1.08)",
            },
          }}
        />
      </a>
    </Box>
  </Stack>
</Paper>
          </Stack>
        </Box>
      </Box>
    </>
  );
}

function HeroPill({ icon, text, style }) {
  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      sx={{
        px: 1.05,
        py: 0.7,
        borderRadius: "999px",
        backgroundColor: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.10)",
        color: style.color4,
      }}
    >
      <Box sx={{ display: "flex", color: style.color3 }}>{icon}</Box>
      <Typography sx={{ fontSize: "0.9rem", fontWeight: 700 }}>{text}</Typography>
    </Stack>
  );
}
